import { Epic, ofType } from 'redux-observable';
import { RootAction, RootState, Services } from 'typesafe-actions';
import { of, from } from 'rxjs';
import { catchError, switchMap, mergeMap } from 'rxjs/operators';
import { addNotification } from '../../../actions/ui';
import {
  DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
  NotificationTypeEnum,
} from '../../../actions/ui/types';
import {
  GET_DEACTIVATED_USERS_FAILURE,
  GET_DEACTIVATED_USERS_REQUEST,
} from '../../../actions/userManagementActions/actionTypes';
import { getDeactivatedUsers } from '../../../actions/userManagementActions';

export const getDeactivatedUsersEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  Services
> = (action$, state$, { api }) =>
  action$.pipe(
    ofType(GET_DEACTIVATED_USERS_REQUEST),
    switchMap((action) =>
      from(
        api.userManagementServices.getDeactivatedUsers(action.payload).pipe(
          mergeMap((response) => of(getDeactivatedUsers.success(response))),
          catchError((err) =>
            of(
              getDeactivatedUsers.failure(err),
              addNotification({
                type: NotificationTypeEnum.ERROR,
                action: GET_DEACTIVATED_USERS_FAILURE,
                body: 'get_deactivated_users_notifications.failure',
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
              })
            )
          )
        )
      )
    )
  );

export default getDeactivatedUsersEpic;
